module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-2.d5886d55.webp";